import { ScrollReveal } from '@/hooks/useScrollReveal';

const WORKSPACE_IMG = 'https://images.unsplash.com/photo-1758608631036-7a2370684905?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjcmVhdGl2ZSUyMHdvcmtzcGFjZSUyMGRlc2slMjBsYXB0b3AlMjBkZXNpZ258ZW58MHx8fHwxNzc0Nzg4MTkzfDA&ixlib=rb-4.1.0&q=85';

const SKILLS = [
  'UI/UX Design', 'HTML & CSS', 'JavaScript', 'React', 'Tailwind CSS',
  'Responsive Design', 'SEO', 'Figma', 'Branding', 'Speed Optimisation',
  'WordPress', 'E-Commerce', 'Analytics', 'Copywriting',
];

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#F8F9FA] dark:bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <ScrollReveal>
              <div className="relative">
                <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-slate-200/20 dark:border-white/5 shadow-xl">
                  <img
                    src={WORKSPACE_IMG}
                    alt="Creative workspace with keyboard, coffee and warm sunlight"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <div className="absolute bottom-0 left-0 p-8">
                    <div className="w-14 h-14 rounded-xl bg-[#00E5FF] flex items-center justify-center mb-3 shadow-lg">
                      <span className="font-['Outfit'] font-black text-[#0A0A0A] text-xl">Ui</span>
                    </div>
                    <p className="text-sm text-white/70 font-medium">Founder & Designer</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-7">
            <ScrollReveal delay={100}>
              <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-slate-400 block mb-4">
                About Me
              </span>
              <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] dark:text-white mb-6">
                The Person Behind The Pixels
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <div className="space-y-4 text-base leading-relaxed text-slate-600 dark:text-slate-400">
                <p>
                  I am a web designer who believes every small business deserves a website that actually works for them — not just looks good, but genuinely helps attract customers and grow.
                </p>
                <p>
                  I work with business owners who are ready to invest in their online presence but want someone who takes the time to understand what they actually need. No templates. No shortcuts. Just thoughtful design and clean code.
                </p>
                <p>
                  When I am not designing, I am probably exploring new tools, keeping up with web standards, or figuring out how to make things load faster.
                </p>
                <p className="mt-2 text-sm text-slate-500 dark:text-slate-500 border-l-2 border-[#00E5FF]/40 pl-4">
                  Proudly serving local businesses across Dorset, including Bournemouth, Poole, Christchurch, and the surrounding areas. We specialise in helping BCP-based companies outrank their competition with high-speed, local-first digital strategies.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="flex flex-wrap gap-2 mt-8">
                {SKILLS.map((skill) => (
                  <span
                    key={skill}
                    data-testid={`skill-bubble-${skill.toLowerCase().replace(/[^a-z]/g, '-')}`}
                    className="px-4 py-1.5 rounded-full text-xs font-semibold border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 text-slate-600 dark:text-slate-400 hover:border-[#00E5FF] hover:text-[#00B4D8] dark:hover:border-[#00E5FF]/40 dark:hover:text-[#00E5FF] transition-colors"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}
